export default __webpack_public_path__ + "static/media/spanish.ed384be4.png";